<div [queryParams]="gift() ? {gift: gift()} : null" [routerLink]="['/product', product().slug]"
     class="bg-white rounded-lg p-2 h-full flex flex-col cursor-pointer group">
  <div class="bg-white h-full rounded-lg p-6 group flex flex-col justify-between">
    <div class="w-full relative">
      <div class="overflow-hidden relative rounded-lg aspect-[11/6]">
        @if (siteService.images(product().id)[0]; as image) {
          <img class="object-cover group-hover:scale-110 transition-all duration-500"
               fill=""
               [alt]="image.alt"
               [ngSrc]="image.media"
               sizes="(max-width: 768) 100vw, (max-width: 1224) 25vw, 20vw">
        } @else {
          <img class="object-cover group-hover:scale-110 transition-all duration-500"
               fill=""
               [alt]="'product/'+product().id+'/name' | translate"
               ngSrc="assets/images/placeholder.webp"
               sizes="(max-width: 768) 100vw, (max-width: 1224) 25vw, 20vw">
        }
      </div>
      @if (price().promo) {
        <p
          class="absolute top-4 left-2 uppercase py-2 px-4 bg-100ciels-300 text-white text-sm font-medium rounded">
          {{ 'promo' | translate }}
        </p>
      }
    </div>
    <h3
      class="text-100ciels-500 text-xl mt-7 uppercase font-semibold">{{ 'product/' + product().id + '/name' | translate }}</h3>
    <div [innerHtml]="'product/'+product().id+'/description' | translate"
         class="text-base mt-3 text-100ciels-500 grow"></div>
    <div class="mt-7 flex justify-between items-center">
      <div class="flex flex-col">
        @if (isGroup()) {
          <span class="text-sm">{{ 'startingFrom' | translate }}</span>
        }
        @if (price(); as p) {
          <div class="font-semibold text-xl flex flex-col">
            @if (p.promo && p.fullPrice) {
              <span class="mr-4 text-100ciels-500 line-through">
                {{ p.fullPrice | currency }}
              </span>
            }
            <span class="text-100ciels-300">
          {{ p.price | currency }}
        </span>
          </div>
        }
      </div>
      <div class="flex flex-row gap-3">
        @if (giftMode()) {
          <a appHoverGradient
             [routerLink]="['/product', product().slug]"
             [queryParams]="{gift: true}"
             class="rounded-full w-40 px-6 text-center text-sm">
            {{ 'offer' | translate }}
          </a>
        } @else {
          <a appHoverGradient
             [routerLink]="['/product', product().slug]"
             class="w-auto px-4 md:px-6 text-center text-sm rounded-full">
            {{ 'learnMore' | translate }} <span
            class="sr-only">{{ 'product/' + product().id + '/name' | translate }}</span>
          </a>
        }
        @if (!isGroup()) {
          <button (click)="addToCart($event)">
            <svg viewBox="0 0 24 24" class="w-9 h-9 block m-auto object-cover">
              <path class="fill-none"
                    stroke="#6b6b6b"
                    stroke-width="1"
                    d="M15.75 10.5V6a3.75 3.75 0 1 0-7.5 0v4.5m11.356-1.993 1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 5.513 7.5h12.974c.576 0 1.059.435 1.119 1.007ZM8.625 10.5a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm7.5 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"/>
            </svg>
            <span class="sr-only">Add to cart</span>
          </button>
        }
      </div>
    </div>
  </div>
</div>
